import React from 'react'

import { Control, FieldErrors, UseFormMethods } from 'react-hook-form'

import { Box, GridItem } from '@chakra-ui/react'

import {
  Button,
  FormInputControl,
  FormInputSelectControl,
} from '@/components/ui'

import { EditDeviceModalSection } from '../../components/EditDeviceModalSection'
import { FourColumnGrid } from '../../components/FourColumnGrid'
import { SectionHeader } from '../../components/SectionHeader'
import { TwoColumnGrid } from '../../components/TwoColumnGrid'
import { FormDataTypeI, Options } from '../../types/types'

interface DeviceDetailsSectionIProps {
  control: Control<FormDataTypeI>
  errors: FieldErrors<FormDataTypeI>
  floorsOptions: Options
  isDevicePlaced: boolean
  isLoading: boolean
  isSaveDisabled: boolean
  isSaveLoading: boolean
  onSave: () => void
  register: UseFormMethods<FormDataTypeI>['register']
}

export const DeviceDetailsSection = ({
  control,
  errors,
  floorsOptions,
  isDevicePlaced,
  isLoading,
  isSaveDisabled,
  isSaveLoading,
  onSave,
  register,
}: DeviceDetailsSectionIProps) => {
  return (
    <EditDeviceModalSection mb={6}>
      <TwoColumnGrid>
        <GridItem>
          <SectionHeader
            subTitle='Configure the basic device information and connections settings for this device '
            title='Device Details & Connection'
          />
        </GridItem>
        <GridItem justifySelf='end'>
          <Button
            isDisabled={isSaveDisabled}
            isLoading={isSaveLoading}
            loadingText='Saving Changes'
            onClick={onSave}
          >
            Save
          </Button>
        </GridItem>
      </TwoColumnGrid>

      <Box>
        <form>
          <FourColumnGrid>
            <GridItem>
              <FormInputControl
                data-testid='devicesPage_editDeviceModal_name'
                errorMessage={errors.name && errors.name.message}
                id='name'
                inputRef={register({
                  required: 'Device Name is required',
                })}
                isInvalid={!!errors.name}
                label='Device Name'
                placeholder='Enter the Device Name'
              />
            </GridItem>
            <GridItem>
              <FormInputSelectControl
                control={control}
                data-testid='devicesPage_editDeviceModal_location'
                defaultValue={null}
                errorMessage={!!errors?.location && 'Select a device location'}
                id='location'
                isClearable
                isDisabled={isLoading || isDevicePlaced}
                isInvalid={!!errors?.location}
                label='Device Location'
                options={floorsOptions}
                placeholder='Select Device Location'
                rules={{ required: true }}
                tooltipText={
                  isDevicePlaced &&
                  'Device must not be placed to update device location'
                }
              />
            </GridItem>
            <GridItem>
              <FormInputControl
                data-testid='devicesPage_editDeviceModal_manufacturerName'
                id='manufacturerName'
                inputRef={register()}
                label='Device Manufacturer'
                placeholder='Enter Name'
              />
            </GridItem>
            <GridItem>
              <FormInputControl
                data-testid='devicesPage_editDeviceModal_externalId'
                errorMessage={errors.externalId?.message}
                id='externalId'
                inputRef={register()}
                label='External ID'
                placeholder='Enter External ID'
                tooltipText='This associates the device with a camera'
              />
            </GridItem>
          </FourColumnGrid>
        </form>
      </Box>
    </EditDeviceModalSection>
  )
}
